import { Suspense, lazy } from 'react'
import { ToastOptions, toast } from 'react-toastify'

const CustomToast = lazy(
  () => import('@cockpitai/components/molecules/ToastCustom'),
)

type TBodyData = {
  title: string
  subtitle?: string
}

type TTypes = 'success' | 'error' | 'alert'

export function useToast() {
  function showToast(
    type: TTypes,
    { title, subtitle }: TBodyData,
    options?: ToastOptions,
  ) {
    toast(
      ({ closeToast }) => (
        <Suspense>
          <CustomToast {...{ title, subtitle, type }} closeToast={closeToast} />
        </Suspense>
      ),
      {
        ...options,
        type: 'error',
        className: '!bg-transparent',
        hideProgressBar: true,
        icon: false,
        position: 'top-center',
        closeButton: false,
      },
    )
  }

  return {
    showToast,
  }
}
